<template>
  <el-dialog
    :title="`安全库存${ edit ? '配置': '查看' }`"
    :visible.sync="visible"
    width="900px"
    append-to-body
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      label-width="100px"
      :model="ruleForm">
      <el-form-item
        label="商品名称：">
        {{ ruleForm.productName }}
      </el-form-item>
      <el-form-item
        label="已选："
        required=""
        prop="list">
        <el-table
          ref="table"
          v-loading="loading"
          height="280"
          border
          :data="ruleForm.multipleSelection">
          <el-table-column
            :resizable="false"
            min-width="150"
            label="仓库名称"
            prop="warehouseName"></el-table-column>
          <el-table-column
            :resizable="false"
            label="仓库编号"
            width="80"
            prop="warehouseNo"></el-table-column>
          <!-- <el-table-column
            min-width="200"
            :resizable="false"
            label="所属部门(公司)"
            prop="departmentName"></el-table-column> -->
          <el-table-column
            :resizable="false"
            width="160"
            label="安全库存">
            <template slot-scope="{row}">
              <template v-if="edit">
                <el-input-number
                  v-model="row.lowQuota"
                  style="width:100%"
                  :min="0"
                  size="mini"
                  :precision="0"
                  placeholder="请输入数量"></el-input-number>
              </template>
              <span v-else>{{ row.lowQuota }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="单位"
            :resizable="false"
            width="50">
            <template slot-scope="{row}">
              {{ ruleForm.measureUnit | measureUnitName() }}
              <span v-if="false">{{ row.warehouseNo }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <div v-show="edit">
        <el-divider>请从下方选择仓库</el-divider>
        <el-form-item
          label="选择仓库：">
          <el-table
            ref="table"
            v-loading="loading"
            height="320px"
            row-key="warehouseId"
            border
            :data="ruleForm.list"
            @selection-change="handleSelectionChange">
            <el-table-column
              type="selection"
              reserve-selection
              width="40">
            </el-table-column>
            <el-table-column
              :resizable="false"
              min-width="150"
              label="仓库名称"
              prop="warehouseName"></el-table-column>
            <el-table-column
              :resizable="false"
              label="仓库编号"
              width="80"
              prop="warehouseNo"></el-table-column>
            <!-- <el-table-column
              min-width="240"
              :resizable="false"
              label="所属部门(公司)"
              prop="departmentName"></el-table-column> -->
          </el-table>
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer">
      <el-button
        v-if="edit"
        type="primary"
        @click="addItem">更新</el-button>
      <el-button @click="toggleModal(false)">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'SafetyStocksModal',
  components: { },
  props: {
    callback: Function,
    edit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      ruleForm: {
        productId: null,
        productName: '',
        measureUnit: null,
        list: [],
        multipleSelection: []
      },
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 1000,
        productType: null,
        useType: 1
      }
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.ruleForm.productId = null
      this.ruleForm.productName = ''
      this.ruleForm.list = []
      this.config.productType = null
      this.$refs.table.clearSelection()
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('outstock/getwarehouses', {
        payload: this.config,
        success: res => {
          this.loading = false
          this.ruleForm.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(row) {
      this.ruleForm.productId = row.productId
      this.ruleForm.productName = row.productName
      this.ruleForm.measureUnit = row.measureUnit
      this.config.productType = row.productType
      this.toggleModal(true)
      this.$nextTick(() => {
        row.list.forEach(s => {
          this.$refs.table.toggleRowSelection(s, true)
        })
        this.fetchList()
      })
    },
    handleSelectionChange(val) {
      const multipleSelection = this.ruleForm.multipleSelection
      const result = val.map(i => {
        const item = multipleSelection.find(s => s.warehouseId === i.warehouseId)
        if (item) {
          return item
        } else {
          return {
            ...i,
            lowQuota: i.lowQuota || 1
          }
        }
      })
      this.$set(this.ruleForm, 'multipleSelection', result)
    },
    addItem() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const result = this.ruleForm.multipleSelection
          if (result.length === 0) {
            this.$message.error('请选择仓库')
            return
          }
          const some = result.some(i => i.lowQuota === undefined || i.lowQuota === null)
          if (some) {
            this.$message.error('安全库存不能为空')
            return
          }
          this.loading = true
          this.$store.dispatch('product/setsafetystock', {
            payload: {
              productId: this.ruleForm.productId,
              oper: 'upd',
              safetyStocks: result.map(i => {
                return {
                  warehouseId: i.warehouseId,
                  lowQuota: i.lowQuota,
                  topQuota: 0
                }
              })
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
